var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7867 24V17.4308H12.9998V15.0656H14.7867V13.0454C14.7867 11.4578 15.8422 10 18.2745 10C19.2592 10 19.9874 10.0918 19.9874 10.0918L19.93 12.3005C19.93 12.3005 19.1874 12.2935 18.377 12.2935C17.4999 12.2935 17.3594 12.6864 17.3594 13.3385V15.0656H19.9998L19.8849 17.4308H17.3594V24H14.7867Z",
    fill: "#192031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    fill: "white",
    transform: "translate(12.9998 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.c17ac71a38a5dc6118633eadcc27c07a.svg";
export { ForwardRef as ReactComponent };